import { RootState } from 'editor/src/store/index';
import getAreaTokenForSpreadName from 'editor/src/store/livePreview/selector/getAreaTokenForSpreadName';

import findSpreadGroundImage from 'editor/src/util/design/findSpreadGroundImage';

// GAPI-30848 — delegate to the shared tech-suffix-insensitive helper.
// See `findSpreadGroundImage` for the rationale: multi-tech spread names
// like `front-dtg` fall back to the catalogue's canonical-area scene
// (`front-dtf` / `front`) when no exact match exists. Last resort: the
// spread's print-area token (AOP ordinal spread names) — see
// `getAreaTokenForSpreadName`.
const getSpreadBackgroundImage = (state: RootState, spreadName: string) =>
  findSpreadGroundImage(state.design.spreadBackgrounds, spreadName) ??
  findSpreadGroundImage(state.design.spreadBackgrounds, getAreaTokenForSpreadName(state, spreadName));

export default getSpreadBackgroundImage;
